<template>
  <div class="navbartop">
    <nav class="row color-back-nav mr-0">
      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-4 col-3 div-menu">
        <div class="sidebar">
          <b-sidebar
            v-show="sidebarIsVisible"
            id="menu"
            shadow
            backdrop
            @shown="retrieve"
          >
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 p-0">
              <div class="header-sidebar modern-header pb-4" slot="header">
                <div
                  class="modern-close-button"
                  @click="sidebarIsVisible = false"
                  v-b-toggle.menu
                >
                  <i class="fas fa-times"></i>
                </div>

                <img
                  class="sidebar-img-logo"
                  :src="require('../assets/logo.png')"
                />
                <h1 class="name-system-menu modern-title mb-0">
                  {{ rest_home_fantasy_name }}
                </h1>
              </div>
              <nav
                id="sidebar"
                v-if="$store.state.online"
                class="modern-sidebar"
              >
                <ul class="list-unstyled pl-0">
                  <li
                    v-if="
                      rest_home_finance == 0 &&
                      !permission('read', 'only_financial')
                    "
                    class="modern-menu-item"
                  >
                    <a
                      @click="handlePage('dashboard')"
                      class="modern-link home-link"
                    >
                      <i class="fas fa-home modern-icon"></i>
                      <span class="modern-text">Dashboard</span>
                    </a>
                  </li>
                  <li
                    v-show="terms == 1"
                    v-for="(i, k) in routesItems"
                    :key="k"
                    :class="['modern-menu-item', current == k && 'active-item']"
                  >
                    <a
                      :href="`#menu_${k}`"
                      data-toggle="collapse"
                      :aria-expanded="current == k ? true : false"
                      :class="[
                        'modern-link dropdown-toggle-modern',
                        current == k && 'collapsed-modern',
                      ]"
                    >
                      <i :class="[i.iconClass, 'modern-icon']"></i>
                      <span class="modern-text">{{ i.title }}</span>
                      <i
                        class="fas fa-chevron-down modern-arrow"
                        :class="{ rotated: current == k }"
                      ></i>
                    </a>
                    <ul
                      v-for="(y, j) in i.routes"
                      :key="j"
                      :class="[
                        'collapse list-unstyled modern-submenu',
                        current == k && 'show',
                      ]"
                      :id="`menu_${k}`"
                    >
                      <li
                        v-for="(x, z) in y.routes"
                        :key="z"
                        v-show="x.show"
                        class="modern-submenu-item"
                      >
                        <a
                          :class="[
                            'modern-sublink',
                            route == x.name && 'route-active-modern',
                          ]"
                          @click="handlePage(`${x.name}`, k)"
                        >
                          <i :class="[x.iconClass, 'modern-subicon']"></i>
                          <span class="modern-subtext">{{
                            x.description
                          }}</span>
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </nav>
              <div v-if="!$store.state.online" class="offline-section">
                <a
                  @click="$router.push({ name: 'dashboard' })"
                  class="modern-link home-link"
                >
                  <ul class="list-unstyled pl-0">
                    <li class="modern-menu-item p-2">
                      <i class="fas fa-home modern-icon"></i>
                      <span class="modern-text">HOME</span>
                    </li>
                  </ul>
                </a>
                <div class="text-center offline-info">
                  <h6 class="offline-title">Sistema em modo offline!</h6>
                  <h6 class="offline-subtitle">ACESSOS DISPONÍVEIS:</h6>
                  <div class="offline-list">
                    <p class="offline-item">Aba Saúde (Sinais Vitais)</p>
                    <p class="offline-item">
                      Aba Rotina Diária (Todas as abas)
                    </p>
                  </div>
                  <div class="offline-warning">
                    <p class="offline-warning-text">
                      Não é possível inserir novas informações.
                    </p>
                    <p class="offline-warning-text">
                      Banco de dados inacessível.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </b-sidebar>
          <div class="d-flex">
            <button
              v-b-toggle.menu
              @click="handleSidebar"
              class="btn-menu-sidebar modern-menu-button"
            >
              <i class="fas fa-bars span-icon" width="20"></i>
            </button>
            <h1
              class="name-system mb-0"
              @click="
                () => {
                  if ($router.currentRoute.name == 'dashboard') $router.go(0);
                  else $router.push({ name: 'dashboard' });
                }
              "
            >
              {{ rest_home_fantasy_name }}
            </h1>
          </div>
        </div>
      </div>
      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-8 col-9 div-account">
        <h6
          class="color-red text-off text-right pr-2 mb-0 pt-1"
          v-if="!$store.state.online"
        >
          OFFLINE <br />
          {{ last_offline_update }}
        </h6>
        <SystemUpdate />

        <!-- Botão de notificação: -->
        <div class="dropdown d-inline-block modern-notification-dropdown">
          <a
            type="button"
            class="btn dropdown-toggle user-navbar notification-btn"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <i class="fas fa-bell"></i>
            <span
              v-if="docsToReadUser.length"
              class="notification-alert-badge"
            ></span>
          </a>

          <div
            class="dropdown-menu dropdown-menu-right dropdown-notification modern-notification-menu"
          >
            <div class="notification-header">
              <i class="fas fa-bell"></i>
              <span class="notification-title">Notificações</span>
            </div>
            <div v-if="docsToReadUser.length" class="notification-list">
              <span class="notification-list-label"
                >Documentos para verificar:</span
              >
              <div
                v-for="doc in docsToReadUser"
                :key="doc.id"
                class="notification-item"
              >
                <div class="notification-doc-info">
                  <i class="fas fa-file-alt notification-doc-icon"></i>
                  <span class="notification-doc-name">{{ doc.doc_name }}</span>
                </div>
                <button
                  class="btn btn-sm btn-primary notification-action-btn"
                  @click="handleDoc(doc)"
                >
                  <i class="fas fa-eye mr-1"></i>
                  Verificar
                </button>
              </div>
            </div>
            <div v-else class="notification-empty">
              <span class="notification-list-label">Sem notificações</span>
            </div>
          </div>
        </div>

        <ConfirmationReading
          @reload="reloadPage"
          :docsToRead="docToRead"
          :onClose="true"
        />

        <v-btn class="mr-2 btn-acess system-update" small @click="handleToHelp">
          <i class="fas fa-question mr-2"></i>
          AJUDA
        </v-btn>
        <v-btn
          v-if="system_update && system_update.status == 1"
          class="mr-2 btn-acess system-update"
          small
          @click="$bvModal.show('system-update')"
        >
          <i class="fas fa-sync-alt mr-2"></i>
          ATUALIZAÇÃO
        </v-btn>
        <div
          :class="[
            'div-photo-url-top',
            $store.state.online ? 'bg-success' : 'bg-danger',
          ]"
        >
          <img
            v-if="!user.photo_url"
            :src="require('../assets/user.svg')"
            class="photo-top-user secondary"
          />
          <img
            v-if="user.photo_url"
            :src="user.photo_url"
            class="photo-top-user"
          />
        </div>
        <h6 class="user-width user-navbar mb-0 mt-1">
          {{ String(user.name).split(" ")[0] }}
        </h6>
        <div class="dropdown d-inline-block modern-user-dropdown">
          <a
            type="button"
            class="btn dropdown-toggle user-navbar user-toggle-btn"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
          </a>
          <div class="dropdown-menu dropdown-menu-right modern-user-menu">
            <button
              v-if="width <= 480"
              class="dropdown-item username-mobile modern-user-item"
              type="button"
            >
              <i class="fas fa-user-circle mr-2 user-icon-mobile"></i>
              {{ String(user.name).split(" ")[0] }}
            </button>
            <button
              v-if="$store.state.online"
              @click="handleToAccount"
              class="dropdown-item modern-user-item"
              type="button"
            >
              <i class="fas fa-user-circle mr-2"></i>
              Minha conta
            </button>
            <button
              @click="logout"
              class="dropdown-item modern-user-item logout-btn"
              type="button"
            >
              <i class="fas fa-sign-out-alt mr-2"></i>
              Sair
            </button>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import ConfirmationReading from "../templates/DocsFolder/ConfirmationReading";
import SystemUpdate from "./Account/SystemUpdate";

import { get } from "idb-keyval";
import { userData } from "../lib/functions";
import permission from "../lib/permission";
import routes from "../routes";
import api from "../services/api";
import moment from "moment";

export default {
  name: "NavBar",

  components: {
    SystemUpdate,
    ConfirmationReading,
  },

  data() {
    return {
      docToRead: [],

      docsToReadUser: [],

      last_offline_update: "",

      accessed_offline: false,

      user: {},

      current: null,

      route: null,

      sidebarIsVisible: true,

      routesItems: [],

      rest_home_fantasy_name: "",

      system_update: undefined,

      width: window.screen.width,

      rest_home_finance: 0,

      terms: 1,
    };
  },

  created() {
    this.getFantasyName();
    this.getDocsToRead();
    this.getOfflineLastUpdate();
    this.retrieve();
    window.addEventListener("resize", this.handleOnResize);
    this.handleOnResize();
  },

  destroyed() {
    window.removeEventListener("resize", this.handleOnResize);
    this.handleOnResize();
  },

  methods: {
    permission,

    async getFantasyName() {
      try {
        const user = await get("user");
        this.rest_home_fantasy_name = user
          ? user.rest_home_fantasy_name
          : "SISTEMA CLIN";
      } catch {
        this.rest_home_fantasy_name = "SISTEMA CLIN";
      }
    },

    async getDocsToRead() {
      try {
        const response = await api.get("/folder/user/read-doc/all");

        const { docsToReadUser } = response.data;

        if (docsToReadUser) {
          this.docsToReadUser = docsToReadUser;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async retrieve() {
      let { user } = userData();

      if (!user) {
        try {
          await this.logout();
        } catch {
          //catch
        } finally {
          routes.push({ name: "sign-in" });
        }
      }

      let { rest_home_finance } = user;

      this.user = user;
      this.rest_home_finance = rest_home_finance;

      let accessed_offline = JSON.parse(
        sessionStorage.getItem("accessed_offline") || !this.$store.state.online
      );

      let system_update = sessionStorage.getItem("system_update");
      if (system_update) {
        this.system_update = JSON.parse(system_update);
      }

      this.accessed_offline = accessed_offline;

      this.mountRoutes();
    },

    async getOfflineLastUpdate() {
      const last_offline_update = await get("last-offline-update");
      this.last_offline_update = moment(last_offline_update).format(
        "DD/MM/YYYY HH:mm:ss"
      );
    },

    async logout() {
      try {
        sessionStorage.removeItem("accessed_offline");
        localStorage.removeItem("residents_cached");
        await api.get("/status/logout");
      } catch (error) {
        console.log(error);
      } finally {
        routes.push({ name: "sign-in" });
      }
    },

    handleOnResize() {
      this.width = window.innerWidth;
    },

    handleSidebar() {
      this.sidebarIsVisible = true;
    },

    mountRoutes() {
      let { import_migrations, medicine_one_third } = routes.currentRoute.query;

      let routesItems = [
        {
          title: "Assinatura digital",
          show: permission("read", "bry_sign"),
          iconClass: "fas fa-file-signature",
          routes: [
            {
              routes: [
                {
                  name: "bry",
                  description: "Assinar",
                  show: true,
                  iconClass: "fas fa-file-signature",
                },
              ],
            },
          ],
        },
        {
          title: "Controle de produtos para comprar",
          show: permission("read", "list") || permission("write", "list"),
          iconClass: "fas fa-list",
          routes: [
            {
              routes: [
                {
                  name: "lists",
                  description: "Listas de produtos",
                  show: permission("read", "list"),
                  iconClass: "fas fa-list",
                },
                {
                  name: "answer-lists",
                  description: "Responder listas",
                  show: permission("write", "list"),
                  iconClass: "fas fa-pen",
                },
              ],
            },
          ],
        },
        {
          title: "Agenda",
          show: permission("read", "schedule"),
          iconClass: "fas fa-calendar",
          routes: [
            {
              routes: [
                {
                  name: "schedule",
                  description: "Calendário",
                  show: true,
                  iconClass: "fas fa-calendar",
                },
              ],
            },
          ],
        },
        {
          title: "Pasta",
          show: permission("read", "folder"),
          iconClass: "fas fa-folder",
          routes: [
            {
              routes: [
                {
                  name: "folder",
                  description: "Ver Pastas",
                  show: true,
                  iconClass: "fas fa-folder-open",
                },
              ],
            },
          ],
        },
        {
          title: "Residentes",
          show:
            permission("read", "resident_health") ||
            permission("read", "resident_daily_routine_medicine_check"),
          iconClass: "fas fa-users",
          routes: [
            {
              routes: [
                {
                  name: "residents-vital-signs-list",
                  description: "Saúde",
                  show: permission("read", "resident_health"),
                  iconClass: "fas fa-list",
                },
                {
                  name: "checks",
                  description: "Checagem de medicamentos",
                  show: permission(
                    "read",
                    "resident_daily_routine_medicine_check"
                  ),
                  iconClass: "fas fa-pills",
                },
              ],
            },
          ],
        },
        {
          title: "Filial",
          show: permission("read", "branch"),
          iconClass: "fas fa-city",
          routes: [
            {
              routes: [
                {
                  name: "branch",
                  description: "Transferência de clientes",
                  show: true,
                  iconClass: "fas fa-exchange-alt",
                },
              ],
            },
          ],
        },
        {
          title: "Médico",
          show: permission("write", "resident_medical_prescription"),
          iconClass: "fas fa-user-md",
          routes: [
            {
              routes: [
                {
                  name: "doctor",
                  description: "Prescrição/Aprazamento",
                  show: true,
                  iconClass: "fas fa-folder",
                },
              ],
            },
          ],
        },
        {
          title: "Semiologia",
          show: permission("read", "semiology"),
          iconClass: "fas fa-th-list",
          routes: [
            {
              routes: [
                {
                  name: "semiology-forms",
                  description: "Formulários",
                  show: true,
                  iconClass: "fas fa-list",
                },
                {
                  name: "resident-answered-semiologies",
                  description: "Formulários respondidos",
                  show: true,
                  iconClass: "fas fa-user-edit",
                },
                {
                  name: "answer-semiologies",
                  description: "Responder formulários",
                  show: true,
                  iconClass: "fas fa-pen",
                },
              ],
            },
          ],
        },
        {
          title: "Cadastro",
          show:
            permission("read", "bed") ||
            permission("read", "type_of_hosting") ||
            permission("read", "resident") ||
            permission("read", "resident_relatives") ||
            permission("read", "provider"),
          iconClass: "fas fa-folder-plus",
          routes: [
            {
              routes: [
                {
                  name: "beds",
                  description: "Leitos",
                  show: permission("read", "bed"),
                  iconClass: "fas fa-bed",
                },
                {
                  name: "types-of-hosting",
                  description: "Tipos de Hospedagens",
                  show: permission("read", "type_of_hosting"),
                  iconClass: "fas fa-th-list",
                },
              ],
            },
            {
              routes: [
                {
                  name: "residents",
                  description: "Residentes",
                  show: permission("read", "resident"),
                  iconClass: "fas fa-users",
                },
                {
                  name: "customers",
                  description: "Familiares",
                  show: permission("read", "resident_relatives"),
                  iconClass: "fas fa-users",
                },
                {
                  name: "providers",
                  description: "Fornecedor",
                  show: permission("read", "provider"),
                  iconClass: "fas fa-user",
                },
              ],
            },
          ],
        },
        {
          title: "Serviços",
          show:
            permission("read", "service_charge_type") ||
            permission("read", "service"),
          iconClass: "fas fa-list-ol",
          routes: [
            {
              routes: [
                {
                  name: "serviceschargetypes",
                  description: "Tipos de cobranças de serviços",
                  show: permission("read", "service_charge_type"),
                  iconClass: "fas fa-file-invoice-dollar",
                },
                {
                  name: "services",
                  description: "Serviços",
                  show: permission("read", "service"),
                  iconClass: "fas fa-th-list",
                },
              ],
            },
          ],
        },
        {
          title: "Usuários",
          show:
            permission("read", "user_group") ||
            permission("read", "user_profile") ||
            permission("read", "user") ||
            permission("read", "permission"),
          iconClass: "fas fa-users",
          routes: [
            {
              routes: [
                {
                  name: "usersgroup",
                  description: "Grupo de usuários",
                  show: permission("read", "user_group"),
                  iconClass: "fas fa-users",
                },
                {
                  name: "usersprofile",
                  description: "Perfil de usuários",
                  show: permission("read", "user_profile"),
                  iconClass: "fas fa-user-circle",
                },
              ],
            },
            {
              routes: [
                {
                  name: "users",
                  description: "Usuários",
                  show: permission("read", "user"),
                  iconClass: "fas fa-users",
                },
                {
                  name: "permissions",
                  description: "Permissões",
                  show: permission("read", "permission"),
                  iconClass: "fas fa-lock-open",
                },
                {
                  name: "devices",
                  description: "Dispositivos",
                  show: permission("read", "devices"),
                  iconClass: "fas fa-desktop",
                },
                {
                  name: "account",
                  description: "Minha Conta",
                  show: true,
                  iconClass: "fas fa-user",
                },
              ],
            },
          ],
        },
        {
          title: "Plantões",
          show: permission("read", "duty"),
          iconClass: "fas fa-briefcase-medical",
          routes: [
            {
              routes: [
                {
                  name: "duty",
                  description: "Gerenciamento",
                  show: permission("read", "duty"),
                  iconClass: "fas fa-cogs",
                },
              ],
            },
          ],
        },
        {
          title: "Medicamentos",
          show: permission("read", "medicine"),
          iconClass: "fas fa-capsules",
          routes: [
            {
              routes: [
                {
                  name: "medicines",
                  description: "Gerenciamento",
                  show: permission("read", "medicine"),
                  iconClass: "fas fa-cogs",
                },
              ],
            },
          ],
        },
        {
          title: "Relatórios",
          show: permission("read", "reports"),
          iconClass: "fas fa-chart-bar",
          routes: [
            {
              routes: [
                {
                  name: "reports",
                  description: "Gerenciamento",
                  show: true,
                  iconClass: "fas fa-cogs",
                },
              ],
            },
          ],
        },
        {
          title: "Administrativo",
          show: permission("read", "graphics"),
          iconClass: "fas fa-th-list",
          routes: [
            {
              routes: [
                {
                  name: "graphics",
                  description: "Gráficos",
                  show: true,
                  iconClass: "fas fa-chart-line",
                },
              ],
            },
          ],
        },
        {
          title: "Importação",
          show: import_migrations,
          iconClass: "fas fa-cogs",
          routes: [
            {
              routes: [
                {
                  name: "import_residents",
                  description: "Importação de residente(s)",
                  show: true,
                  iconClass: "fas fa-file-import",
                },
                {
                  name: "import_users",
                  description: "Importação de usuários(s)",
                  show: true,
                  iconClass: "fas fa-file-import",
                },
              ],
            },
          ],
        },
        {
          title: "Configurar estoque 0.33",
          show: medicine_one_third,
          iconClass: "fas fa-list",
          routes: [
            {
              routes: [
                {
                  name: "medicine-one-third",
                  description: "Configurar",
                  show: true,
                  iconClass: "fas fa-list",
                },
              ],
            },
          ],
        },
        {
          title: "Financeiro",
          show: permission("read", "financial"),
          iconClass: "fas fa-piggy-bank",
          routes: [
            {
              routes: [
                {
                  name: "financial",
                  description: "Gerenciamento",
                  show: true,
                  iconClass: "fas fa-cogs",
                },
              ],
            },
          ],
        },
        {
          title: "Familiares",
          show: false,
          iconClass: "fas fa-list",
          routes: [
            {
              routes: [
                {
                  name: "family_residents",
                  description: "Residentes",
                  show: true,
                  iconClass: "fas fa-users",
                },
              ],
            },
          ],
        },
        {
          title: "Configurações",
          show:
            permission("read", "config_stock_config") ||
            permission("read", "config_advance_notification") ||
            permission("read", "config_nfe_change_name_item") ||
            permission("read", "config_home_care"),
          iconClass: "fas fa-cogs",
          routes: [
            {
              routes: [
                {
                  name: "stock-config",
                  description: "Estoque para separação/checagem",
                  show: permission("read", "config_stock_config"),
                  iconClass: "fas fa-box",
                },
                {
                  name: "advance-notification",
                  description: "Notificação antecipada para separação/checagem",
                  show: permission("read", "config_advance_notification"),
                  iconClass: "fas fa-envelope",
                },
                {
                  name: "nfe-change-name-item",
                  description:
                    "Importação de produtos da nota fiscal na compra",
                  show: permission("read", "config_nfe_change_name_item"),
                  iconClass: "fas fa-cogs",
                },
                {
                  name: "config-home-care",
                  description: "Home care / Família",
                  show: permission("read", "config_home_care"),
                  iconClass: "fas fa-cogs",
                },
              ],
            },
          ],
        },
        {
          title: "Estoque",
          show:
            permission("write", "rest_home_transfer_medicine_resident") ||
            (permission("read", "financial") &&
              permission("write", "main_stock_shopping")) ||
            permission("write", "rest_home_transfer_medicine_resident") ||
            permission("read", "readjustment_service") ||
            permission("read", "readjustment_type_of_hosting") ||
            permission("write", "main_stock_input") ||
            permission("write", "main_stock_transfer") ||
            permission("write", "main_stock_output") ||
            permission("read", "main_stock_reversal") ||
            permission("read", "product") ||
            permission("read", "medicine") ||
            permission("read", "stock") ||
            permission("read", "duty"),
          iconClass: "fas fa-box",
          routes: [
            {
              routes: [
                {
                  name: "new-stock",
                  description: "Gerenciar",
                  show: true,
                  iconClass: "fas fa-cogs",
                },
              ],
            },
          ],
        },
      ];

      let newRoutes = [];

      let routeName = routes.currentRoute.name;

      let key = 0;
      for (let item of routesItems) {
        if (item.show) {
          for (let k of item.routes) {
            for (let y of k.routes) {
              if (y.name == routeName) {
                this.route = routeName;
                this.current = key;
              }
            }
          }
          newRoutes.push(item);
        }
        key++;
      }

      this.routesItems = newRoutes;
    },

    handlePage(name) {
      this.route = name;
      if (routes.currentRoute.name !== name) {
        routes.push({ name });
      } else {
        this.sidebarIsVisible = false;
      }
    },

    handleToHelp() {
      if (routes.currentRoute.name != "help") {
        routes.push({ name: "help" });
      }
    },

    handleToAccount() {
      if (routes.currentRoute.name != "account") {
        routes.push({ name: "account" });
      }
    },

    handleDoc(docToRead) {
      this.docToRead = docToRead;

      this.$nextTick(() => {
        this.$bvModal.show(`ConfirmationReading-${this.docToRead.id}`);
      });
    },

    reloadPage() {
      window.location.reload();
    },
  },
};
</script>

<style>
/* Navbar top styling */
.navbartop .color-back-nav {
  background-color: #0f65b0 !important;
}

.navbartop .system-update {
  height: 35px !important;
}

.navbartop .div-photo-url-top {
  width: 35px !important;
  height: 35px !important;
  border-radius: 17.5px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Modern Sidebar Styling */
.modern-sidebar {
  /* background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%) !important; */
  background-color: #fff;
  min-height: 100vh;
  padding: 0;
}

.modern-header {
  /* background: linear-gradient(135deg, #0f65b0 0%, #0f65b0 100%) !important; */
  background-color: #fff;
  color: white !important;
  padding: 24px 20px !important;
  border-radius: 0 0 20px 20px;
  margin-bottom: 20px;
}

.modern-title {
  color: white !important;
  font-size: 18px !important;
  font-weight: 600 !important;
  margin-top: 12px !important;
}

/* Menu Items */
.modern-menu-item {
  margin-bottom: 8px;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.modern-link {
  display: flex !important;
  align-items: center !important;
  padding: 8px 10px !important;
  color: #4a5568 !important;
  text-decoration: none !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  border-radius: 12px !important;
  margin: 0 12px !important;
  transition: all 0.3s ease !important;
  background: rgba(255, 255, 255, 0.7) !important;
  backdrop-filter: blur(10px) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
}

.modern-link:hover {
  background: rgba(102, 126, 234, 0.1) !important;
  color: #0f65b0 !important;
  text-decoration: none !important;
  transform: translateX(4px) !important;
  box-shadow: 0 4px 20px rgba(102, 126, 234, 0.15) !important;
}

.modern-icon {
  color: #0f65b0 !important;
  width: 20px !important;
  margin-right: 12px !important;
  font-size: 16px !important;
}

.modern-text {
  flex: 1 !important;
  font-weight: 500 !important;
}

.modern-arrow {
  color: #a0aec0 !important;
  font-size: 12px !important;
  transition: transform 0.3s ease !important;
  margin-left: auto !important;
}

.modern-arrow.rotated {
  transform: rotate(180deg) !important;
}

/* Active states */
.active-item .modern-link {
  background: rgba(102, 126, 234, 0.15) !important;
  color: #0f65b0 !important;
  box-shadow: 0 4px 20px rgba(102, 126, 234, 0.2) !important;
}

.active-item .modern-icon {
  color: #0f65b0 !important;
}

/* Home link special styling */
.home-link {
  background: linear-gradient(135deg, #0f65b0 0%, #0f65b0 100%) !important;
  color: white !important;
}

.home-link:hover {
  background: linear-gradient(135deg, #0f65b0 0%, #0f65b0 100%) !important;
  color: white !important;
  transform: translateX(4px) !important;
}

.home-link .modern-icon {
  color: white !important;
}

/* Submenu styling */
.modern-submenu {
  background: transparent !important;
  padding: 0 !important;
  margin: 8px 0 0 0 !important;
}

.modern-submenu-item {
  margin-bottom: 4px !important;
}

.modern-sublink {
  display: flex !important;
  align-items: center !important;
  padding: 6px 10px 6px 26px !important;
  color: #718096 !important;
  text-decoration: none !important;
  font-size: 13px !important;
  font-weight: 400 !important;
  border-radius: 8px !important;
  margin: 0 12px !important;
  transition: all 0.3s ease !important;
  background: rgba(255, 255, 255, 0.5) !important;
}

.modern-sublink:hover {
  background: rgba(102, 126, 234, 0.08) !important;
  color: #0f65b0 !important;
  text-decoration: none !important;
  transform: translateX(4px) !important;
}

.modern-subicon {
  color: #a0aec0 !important;
  width: 16px !important;
  margin-right: 10px !important;
  font-size: 14px !important;
}

.modern-subtext {
  font-weight: 400 !important;
}

/* Route active state */
.route-active-modern {
  background: rgba(102, 126, 234, 0.12) !important;
  color: #0f65b0 !important;
  font-weight: 500 !important;
}

.route-active-modern .modern-subicon {
  color: #0f65b0 !important;
}

/* Menu button */
.modern-menu-button {
  background: linear-gradient(135deg, #0f65b0 0%, #0f65b0 100%) !important;
  border: none !important;
  border-radius: 12px !important;
  width: 50px !important;
  height: 50px !important;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3) !important;
  transition: all 0.3s ease !important;
}

.modern-menu-button:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4) !important;
}

/* Offline section */
.offline-section {
  padding: 20px !important;
}

.offline-info {
  background: rgba(255, 255, 255, 0.9) !important;
  border-radius: 12px !important;
  padding: 20px !important;
  margin-top: 20px !important;
}

.offline-title {
  color: #e53e3e !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  margin-bottom: 12px !important;
}

.offline-subtitle {
  color: #4a5568 !important;
  font-size: 12px !important;
  font-weight: 500 !important;
  margin-bottom: 12px !important;
}

.offline-list {
  margin-bottom: 16px !important;
}

.offline-item {
  color: #4a5568 !important;
  font-size: 13px !important;
  margin-bottom: 4px !important;
  text-transform: uppercase !important;
}

.offline-warning {
  border-top: 1px solid #e2e8f0 !important;
  padding-top: 12px !important;
}

.offline-warning-text {
  color: #718096 !important;
  font-size: 11px !important;
  margin-bottom: 2px !important;
  text-transform: uppercase !important;
}

/* Sidebar header logo */
.sidebar .sidebar-img-logo {
  width: 100% !important;
  height: 30px !important;
  object-fit: contain !important;
  /* filter: brightness(0) invert(1) !important; */
}

/* Override default sidebar styles */
.b-sidebar > .b-sidebar-header {
  padding: 0px !important;
}

.sidebar .background-color-sidebar {
  background: transparent !important;
}

/* Modern Close Button Styling */
.sidebar .btn-close,
.sidebar button.close,
.b-sidebar-header .btn-close,
.b-sidebar-header button.close {
  display: none;
}

.sidebar .btn-close:hover,
.sidebar button.close:hover,
.b-sidebar-header .btn-close:hover,
.b-sidebar-header button.close:hover {
  background: rgba(231, 76, 60, 0.9) !important;
  color: white !important;
  transform: scale(1.1) rotate(90deg) !important;
  box-shadow: 0 4px 20px rgba(231, 76, 60, 0.4) !important;
  border-color: rgba(231, 76, 60, 0.3) !important;
}

.sidebar .btn-close:active,
.sidebar button.close:active,
.b-sidebar-header .btn-close:active,
.b-sidebar-header button.close:active {
  transform: scale(0.95) rotate(90deg) !important;
}

.sidebar .btn-close:focus,
.sidebar button.close:focus,
.b-sidebar-header .btn-close:focus,
.b-sidebar-header button.close:focus {
  outline: none !important;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.3) !important;
}

/* Close button icon styling */
.sidebar .btn-close::before,
.sidebar button.close::before {
  content: "✕" !important;
  font-weight: 300 !important;
  font-size: 16px !important;
  line-height: 1 !important;
}

/* Override Bootstrap Vue close button */
.b-sidebar-header .close {
  position: absolute !important;
  top: 20px !important;
  right: 20px !important;
  width: 40px !important;
  height: 40px !important;
  border-radius: 50% !important;
  background: rgba(255, 255, 255, 0.15) !important;
  backdrop-filter: blur(10px) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  color: white !important;
  font-size: 16px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  transition: all 0.3s ease !important;
  opacity: 1 !important;
  text-shadow: none !important;
  padding: 0 !important;
  margin: 0 !important;
  cursor: pointer !important;
}

.b-sidebar-header .close:hover {
  background: rgba(231, 76, 60, 0.9) !important;
  color: white !important;
  transform: scale(1.1) rotate(90deg) !important;
  box-shadow: 0 4px 20px rgba(231, 76, 60, 0.4) !important;
  border-color: rgba(231, 76, 60, 0.3) !important;
}

.b-sidebar-header .close:focus {
  outline: none !important;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.3) !important;
}

/* Icon inside close button */
.sidebar button.close svg,
.b-sidebar-header .close svg {
  width: 16px !important;
  height: 16px !important;
  color: currentColor !important;
}

.sidebar button.close svg g,
.b-sidebar-header .close svg g {
  color: currentColor !important;
}

/* Alternative close button styling with custom icon */
.modern-close-button {
  position: absolute !important;
  top: 20px !important;
  right: 30px !important;
  width: 40px !important;
  height: 40px !important;
  border-radius: 50% !important;
  background: rgba(255, 255, 255, 0.15) !important;
  backdrop-filter: blur(10px) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  color: white !important;
  cursor: pointer !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  transition: all 0.3s ease !important;
  z-index: 1000 !important;
}

.modern-close-button:hover {
  background: rgba(231, 76, 60, 0.9) !important;
  color: white !important;
  transform: scale(1.1) rotate(90deg) !important;
  box-shadow: 0 4px 20px rgba(231, 76, 60, 0.4) !important;
}

.modern-close-button:focus {
  outline: none !important;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.3) !important;
}

.modern-close-button i {
  font-size: 14px !important;
  transition: transform 0.3s ease !important;
}

/* Tooltip for close button */
.modern-close-button::after,
.sidebar .btn-close::after,
.sidebar button.close::after {
  position: absolute !important;
  bottom: -35px !important;
  right: 0 !important;
  background: rgba(0, 0, 0, 0.8) !important;
  color: white !important;
  padding: 4px 8px !important;
  border-radius: 4px !important;
  font-size: 12px !important;
  opacity: 0 !important;
  transform: translateY(-5px) !important;
  transition: all 0.3s ease !important;
  pointer-events: none !important;
  white-space: nowrap !important;
}

.modern-close-button:hover::after,
.sidebar .btn-close:hover::after,
.sidebar button.close:hover::after {
  opacity: 1 !important;
  transform: translateY(0) !important;
}

/* Scrollbar styling */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  /* background: rgba(255, 255, 255, 0.1); */
  background: #fff;
}

::-webkit-scrollbar-thumb {
  background: #0f65b0;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(102, 126, 234, 0.5);
}

.modern-notification-dropdown .notification-btn {
  color: #0f65b0;
  background: none;
  border: none;
  font-size: 22px;
  transition: color 0.2s;
}

.modern-notification-dropdown .notification-btn:hover,
.modern-notification-dropdown .notification-btn:focus {
  color: #1e40af;
  background: none;
  outline: none;
}

.modern-notification-menu {
  min-width: 350px;
  padding: 0;
  border-radius: 16px;
  box-shadow: 0 6px 24px rgba(15, 101, 176, 0.1);
  background: #f8fafc;
  border: none;
  overflow: hidden;
}

.notification-header {
  display: flex;
  align-items: center;
  gap: 10px;
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%);
  color: #fff;
  padding: 16px 20px;
  font-weight: 600;
  font-size: 16px;
}

.notification-title {
  font-size: 16px;
  letter-spacing: 0.2px;
}

.notification-list {
  padding: 16px 20px 8px 20px;
}

.notification-list-label {
  font-size: 13px;
  color: #64748b;
  font-weight: 500;
  margin-bottom: 10px;
  display: block;
}

.notification-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  padding: 12px 16px;
  border-radius: 10px;
  margin-bottom: 10px;
  box-shadow: 0 2px 8px rgba(15, 101, 176, 0.04);
  border: 1px solid #e5e7eb;
  transition: box-shadow 0.2s;
}

.notification-item:hover {
  box-shadow: 0 4px 16px rgba(15, 101, 176, 0.1);
}

.notification-doc-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.notification-doc-icon {
  color: #0f65b0;
  font-size: 16px;
}

.notification-doc-name {
  font-size: 14px;
  color: #1e293b;
  font-weight: 500;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.notification-action-btn {
  padding: 8px 16px !important;
  border-radius: 8px !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%) !important;
  color: #fff !important;
  box-shadow: 0 2px 8px rgba(15, 101, 176, 0.08) !important;
  border: none !important;
  display: flex;
  align-items: center;
  gap: 4px;
  transition: background 0.2s, box-shadow 0.2s;
}

.notification-action-btn:hover {
  background: linear-gradient(135deg, #1e40af 0%, #0f65b0 100%) !important;
  box-shadow: 0 4px 12px rgba(15, 101, 176, 0.15) !important;
}

.notification-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 0;
  color: #10b981;
  font-size: 15px;
  font-weight: 500;
  gap: 8px;
  background: #fff;
}

.notification-empty i {
  font-size: 28px;
}

.position-relative {
  position: relative;
}

.notification-alert-badge {
  position: absolute;
  top: 10px;
  left: 20px;
  width: 8px;
  height: 8px;
  background: #ef4444;
  border-radius: 50%;

  z-index: 2;
  display: inline-block;
  transition: background 0.2s;
}

.modern-user-dropdown .user-toggle-btn {
  color: #0f65b0;
  background: none;
  border: none;
  font-size: 22px;
  transition: color 0.2s;
  padding: 0 8px;
}

.modern-user-dropdown .user-toggle-btn:hover,
.modern-user-dropdown .user-toggle-btn:focus {
  color: #1e40af;
  background: none;
  outline: none;
}

.modern-user-menu {
  min-width: 220px;
  padding: 0;
  border-radius: 16px;
  box-shadow: 0 6px 24px rgba(15, 101, 176, 0.1);
  background: #f8fafc;
  border: none;
  overflow: hidden;
}

.modern-user-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 24px;
  font-size: 15px;
  font-weight: 500;
  color: #1e293b;
  background: none;
  border: none;
  width: 100%;
  transition: background 0.2s, color 0.2s;
}

.modern-user-item i {
  font-size: 17px;
  color: #0f65b0;
}

.modern-user-item:active,
.modern-user-item:focus,
.modern-user-item:hover {
  background: linear-gradient(135deg, #0f65b010 0%, #1e40af08 100%);
  color: #0f65b0;
}

.logout-btn {
  color: #dc2626 !important;
}

.logout-btn i {
  color: #dc2626 !important;
}

.username-mobile {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  color: #1e293b;
  font-weight: 600;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 4px;
  padding: 14px 24px;
}

.user-icon-mobile {
  color: #0f65b0;
  font-size: 18px;
}

/* Responsive design */
@media (max-width: 768px) {
  .modern-link {
    font-size: 13px !important;
    padding: 14px 16px !important;
  }

  .modern-sublink {
    font-size: 12px !important;
    padding: 10px 16px 10px 44px !important;
  }

  .modern-header {
    padding: 20px 16px !important;
  }

  .modern-title {
    font-size: 16px !important;
  }

  /* Close button responsive adjustments */
  .sidebar .btn-close,
  .sidebar button.close,
  .b-sidebar-header .btn-close,
  .b-sidebar-header button.close,
  .modern-close-button {
    top: 15px !important;
    right: 15px !important;
    width: 36px !important;
    height: 36px !important;
  }

  .sidebar .btn-close::before,
  .sidebar button.close::before {
    font-size: 14px !important;
  }

  .modern-close-button i {
    font-size: 12px !important;
  }
}

/* Animation for smooth transitions */
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.4);
  }
  70% {
    box-shadow: 0 0 0 6px rgba(255, 255, 255, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
  }
}

.modern-menu-item {
  animation: slideIn 0.3s ease forwards;
}

.modern-menu-item:nth-child(1) {
  animation-delay: 0.1s;
}
.modern-menu-item:nth-child(2) {
  animation-delay: 0.2s;
}
.modern-menu-item:nth-child(3) {
  animation-delay: 0.3s;
}
.modern-menu-item:nth-child(4) {
  animation-delay: 0.4s;
}
.modern-menu-item:nth-child(5) {
  animation-delay: 0.5s;
}

/* Subtle pulse animation for close button on first load */
.modern-close-button,
.sidebar .btn-close,
.sidebar button.close,
.b-sidebar-header .btn-close,
.b-sidebar-header button.close {
  animation: pulse 2s infinite;
}

.modern-close-button:hover,
.sidebar .btn-close:hover,
.sidebar button.close:hover,
.b-sidebar-header .btn-close:hover,
.b-sidebar-header button.close:hover {
  animation: none;
}
</style>